<div class="w100">
    <video class="w100"
        [src]="url" 
        controls >
    </video>
</div>